module.exports = __webpack_public_path__ + "mw.svg?f075545eec970dd6bea4083002f29084";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/mw.svg
// module id = 1266
// module chunks = 0